"use client";

import { useState } from "react";
import Image from "next/image";
import { Newspaper } from "lucide-react";

// Toont de nieuwsfoto van de live site; valt terug op een nette placeholder
// als de foto ontbreekt of niet laadt. Via next/image, zodat de onbewerkte
// bestanden van ntto.nl verkleind worden voordat ze naar de telefoon gaan.
// De ouder van dit component moet `relative` zijn, want we vullen die op.
export function NieuwsFoto({ src, alt }: { src: string | null; alt: string }) {
  const [fout, setFout] = useState(false);

  if (!src || fout) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-card to-[#0f2233]">
        <Newspaper className="size-8 text-white/20" aria-hidden />
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill
      // De app is maximaal 448px breed (max-w-md), dus meer hoeven we nooit te laden.
      sizes="(max-width: 448px) 100vw, 448px"
      onError={() => setFout(true)}
      className="object-cover"
    />
  );
}
